import React from 'react';
import SnookerSection from '../components/SnookerSection';
import ReviewCarousel from '../components/ReviewCarousel';

const SnookerPage: React.FC = () => {
  const snookerImages = [
    {
      src: '/images/snooker/2026/snooker-club-01.webp',
      alt: 'The Creamery Snooker Tables'
    },
    {
      src: '/images/snooker/2026/snooker-club-02.webp',
      alt: 'The Creamery Snooker Tables'
    },
    {
      src: '/images/snooker/2026/snooker-club-03.webp',
      alt: 'The Creamery Snooker Tables'
    },
    {
      src: '/images/snooker/2026/snooker-club-04.webp',
      alt: 'The Creamery Snooker Tables'
    },
    {
      src: '/images/snooker/2026/snooker-club-05.webp',
      alt: 'The Creamery Snooker Tables'
    },
    {
      src: '/images/snooker/2026/snooker-club-06.webp',
      alt: 'The Creamery Snooker Tables'
    },
    {
      src: '/images/snooker/2026/snooker-club-07.webp',
      alt: 'The Creamery Snooker Tables'
    },
    {
      src: '/images/snooker/2026/snooker-club-08.webp',
      alt: 'The Creamery Snooker Tables'
    },
    {
      src: '/images/snooker/2026/snooker-club-09.webp',
      alt: 'The Creamery Snooker Tables'
    },
  ];

  return (
    <div className="pt-20 bg-primary-black">
      <SnookerSection 
        showGallery={true}
        showCoachingBanner={true}
        eyebrow="SNOOKER"
        title="Snooker Hall"
        subtitle="We have 10 full-size snooker tables available for hire — whether you're a casual player or a serious competitor we have the right table for you."
        tableType="snooker"
        snookerTables="10"
        galleryImages={snookerImages}
      />
      <ReviewCarousel type="snooker" />
      {/* Reservation CTA Section */}
      <section className="relative py-20 bg-primary-black overflow-hidden">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-gold opacity-5 rounded-full blur-3xl"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-gold mb-6 font-display">
            Book Your Table
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            Reserve a snooker or pool table for your next game
          </p>
          <a 
            href="/book" 
            className="inline-block bg-primary-gold text-primary-black px-12 py-4 rounded-full font-semibold text-lg hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
            aria-label="Reserve a snooker table"
          >
            Make a Reservation
          </a>
        </div>
      </section>
    </div>
  );
};

export default SnookerPage;
